"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _try = _interopRequireWildcard(require("./try"));
var _util = require("./util");
var _tracekit = _interopRequireDefault(require("tracekit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var monitor = {};
monitor.tryJS = _try.default;
(0, _try.setting)({
  handleTryCatchError: handleTryCatchError
});
monitor.init = function (opts) {
  __config(opts);
  __init();
};

// 忽略错误监听
window.ignoreError = false;
// 错误日志列表
var errorList = [];
// 错误处理回调
var report = function report() {};
var config = {
  concat: true,
  delay: 2000,
  // 错误处理间隔时间
  maxError: 16,
  // 异常报错数量限制
  sampling: 1 // 采样率
};

// 定义的错误类型码
var ERROR_RUNTIME = 1;
var ERROR_SCRIPT = 2;
var ERROR_STYLE = 3;
var ERROR_IMAGE = 4;
var ERROR_AUDIO = 5;
var ERROR_VIDEO = 6;
var ERROR_CONSOLE = 7;
var ERROR_TRY_CATHC = 8;
var LOAD_ERROR_TYPE = {
  SCRIPT: ERROR_SCRIPT,
  LINK: ERROR_STYLE,
  IMG: ERROR_IMAGE,
  AUDIO: ERROR_AUDIO,
  VIDEO: ERROR_VIDEO
};
function __config(opts) {
  (0, _util.merge)(opts, config);
  report = (0, _util.debounce)(config.report, config.delay, function () {
    errorList = [];
  });
}
function __init() {
  // 监听 JavaScript 报错异常(JavaScript runtime error)
  // window.onerror = function (msg, url, row, col, error) {
  //   console.log('onerror=========')
  //   console.log(msg)
  //   console.log(url)
  //   console.log(row)
  //   console.log(col)
  //   console.log(error)
  //   // handleError(formatRuntimerError.apply(null, arguments))
  //   console.log('onerror=========')
  // }

  // 为了捕获跨域js的错误，使用try...catch做了一层劫持
  // proxyAddEventListener()

  // 监听资源加载错误(JavaScript Scource failed to load)
  // 监听资源加载错误(JavaScript Scource failed to load)
  window.addEventListener('error', function (event) {
    console.log('addEventListener error');
    // 过滤 target 为 window 的异常，避免与上面的 onerror 重复
    var errorTarget = event.target;
    if (errorTarget && errorTarget !== window && errorTarget.nodeName && LOAD_ERROR_TYPE[errorTarget.nodeName.toUpperCase()]) {
      handleError(formatLoadError(errorTarget));
    } else {
      // onerror会被覆盖, 因此转为使用Listener进行监控
      // let { type } = formatRuntimerError()
      // event.type = type
      try {
        _tracekit.default.report(event.error);
      } catch (error) {}
    }
  }, true);
  //监听开发中浏览器中捕获到未处理的Promise错误
  window.addEventListener('unhandledrejection', function (event) {
    // TraceKit.report(event)
  }, true);

  // 针对 vue 报错重写 console.error
  // TODO
  // console.error = (function (origin) {
  //   return function (info) {
  //     console.log(info)
  //     var errorLog = {
  //       type: ERROR_CONSOLE,
  //       desc: info
  //     }

  //     handleError(errorLog)
  //     origin.call(console, info)
  //   }
  // })(console.error)

  monitor.trackerVue = function (Vue) {
    console.log('trackerVue开始监听');
    Vue.config.errorHandler = function (err, vm, info) {
      console.log('errorHandler 捕捉错误');
      _tracekit.default.report(err);
      // 这里是为了让异常还能抛出到浏览器上
      console.log(err);
    };
    Vue.config.asyncErrorHandler = function (err) {
      console.log('asyncErrorHandler 捕捉错误');
      _tracekit.default.report(err);
      console.log(err);
    };
    Vue.config.errorCaptured = function (err) {
      console.log('errorCaptured 捕捉错误');
      _tracekit.default.report(err);
      console.log(err);
    };
  };
}

// 为了捕获跨域js的错误，使用try...catch做了一层劫持
// function proxyAddEventListener() {
//   const nativeAddEventListener = EventTarget.prototype.addEventListener
//   EventTarget.prototype.addEventListener = function (type, func, options) {
//     const wrappedFunc = function (...args) {
//       try {
//         return func.apply(this, args)
//       } catch (e) {
//         // const errorObj = {
//         //   error_msg: e.message || '',
//         //   error_stack: e.stack || (e.error && e.error.stack) || '',
//         //   error_catched_type: e['error_catched_type'] || ERROR_TYPE['EVENT'],
//         //   error_native: e
//         // }
//         console.log('addEventListener error')
//         // 过滤 target 为 window 的异常，避免与上面的 onerror 重复
//         var errorTarget = e.target
//         if (errorTarget && errorTarget !== window && errorTarget.nodeName && LOAD_ERROR_TYPE[errorTarget.nodeName.toUpperCase()]) {
//           handleError(formatLoadError(errorTarget))
//         } else {
//           // onerror会被覆盖, 因此转为使用Listener进行监控
//           // let { type } = formatRuntimerError()
//           // event.type = type
//           try {
//             TraceKit.report(e.error)
//           } catch (error) {}
//         }
//       }
//     }
//     return nativeAddEventListener.call(this, type, wrappedFunc, options)
//   }
// }

// 处理 try..catch 错误
function handleTryCatchError(error) {
  _tracekit.default.report(error);
}

/**
 * 生成 runtime 错误日志
 *
 * @param  {String} message 错误信息
 * @param  {String} source  发生错误的脚本 URL
 * @param  {Number} lineno  发生错误的行号
 * @param  {Number} colno   发生错误的列号
 * @param  {Object} error   error 对象
 * @return {Object}
 */
function formatRuntimerError(message, source, lineno, colno, error) {
  return {
    type: ERROR_RUNTIME
  };
}

/**
 * 生成 laod 错误日志
 *
 * @param  {Object} errorTarget
 * @return {Object}
 */
function formatLoadError(errorTarget) {
  return {
    type: LOAD_ERROR_TYPE[errorTarget.nodeName.toUpperCase()],
    desc: errorTarget.baseURI + '@' + (errorTarget.src || errorTarget.href),
    stack: '静态资源加载错误'
  };
}

/**
 * 生成 try..catch 错误日志
 *
 * @param  {Object} error error 对象
 * @return {Object} 格式化后的对象
 */
function formatTryCatchError(error) {
  return {
    type: ERROR_TRY_CATHC,
    desc: error.message,
    stack: error.stack
  };
}
_tracekit.default.report.subscribe(function (errorReport) {
  // 在这里可以通过ajax进行数据上报
  errorReport.desc = errorReport.message;
  handleError(errorReport);
});

/**
 * 错误数据预处理
 *
 * @param  {Object} errorLog    错误日志
 */
function handleError(errorLog) {
  // 是否延时处理
  if (!config.concat) {
    !needReport(config.sampling) || config.report([errorLog]);
  } else {
    pushError(errorLog);
    report(errorList);
  }
}

/**
 * 往异常信息数组里面添加一条记录
 *
 * @param  {Object} errorLog 错误日志
 */
function pushError(errorLog) {
  if (needReport(config.sampling) && errorList.length < config.maxError) {
    errorList.push(errorLog);
  }
}

/**
 * 设置一个采样率，决定是否上报
 *
 * @param  {Number} sampling 0 - 1
 * @return {Boolean}
 */
function needReport(sampling) {
  return Math.random() < (sampling || 1);
}
var _default = monitor;
exports.default = _default;